var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout full",staticStyle:{"overflow":"auto"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }